module.exports = __webpack_public_path__ + "img/menu_active.79982979.svg";